import Page from "./Page";
import View from "./View";

export default class ParentView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     */
    constructor(parentId, elementId) {
        super(parentId, elementId);

        /**
         * The array of views contained by this view.
         * @private
         * @type {Array.<View>}
         */
        this.childViews = null;
    }

    /**
     * @returns {View[]}
     */
    getChildViews() {
        return this.childViews;
    }

    /**
     * Clears out all child views.
     */
    clearChildViews() {
        if (this.childViews && this.childViews.length > 0) {
            for (let i = 0; i < this.childViews.length; i++) {
                this.childViews[i].clearChildViews();
            }
            this.childViews.length = 0;
        }
    }

    /**
     * @override
     */
    removeAll() {

        // Remove all child views
        // Remove all child view elements

        if (this.childViews) {
            for (let i = 0; i < this.childViews.length; i++) {
                this.childViews[i].removeAll();
            }
        }
        this.childViews = null;

        super.removeAll();
    }

    /**
     * Clears out all child view elements and also clears the child view array.
     */
    removeChildViewElements() {
        if (!this.childViews || this.childViews.length === 0) {
            return;
        }

        const id = this.getElementId();
        for (let i = 0; i < this.childViews.length; i++) {
            Page.removeElementById(id, this.childViews[i].getElementId());
        }

        this.clearChildViews();
    }

    /**
     * @param {number} index
     */
    removeViewAtIndex(index) {
        if (!this.childViews || this.childViews.length === 0) {
            return;
        }

        const child = this.childViews[index];

        const id = this.getElementId();
        Page.removeElementById(id, child.getElementId());
        this.childViews.splice(index, 1);
    }

    /**
     * @param {string} elementId 
     */
    removeView(elementId) {
        if (!this.childViews || this.childViews.length === 0) {
            return;
        }

        const id = this.getElementId();

        let childIndex = -1;
        for (let i = 0; i < this.childViews.length; i++) {
            const child = this.childViews[i];
            if (child.getElementId() === elementId) {
                childIndex = i;
                break;
            }
        }

        if (childIndex === -1) {
            console.log('ParentView.removeView() Failed to find child id: ' + elementId);
            return;
        }

        const child = this.childViews[childIndex];

        Page.removeElementById(id, child.getElementId());
        this.childViews.splice(childIndex, 1);
    }

    /**
     * Adds a view to the parent.
     * @param {View} view
     */
    addView(view) {
        if (view) {
            if (!this.childViews) {
                this.childViews = [];
            }
            this.childViews.push(view);
        }
    }

    /**
     * @inheritDoc
     */
    initializeView() {
        if (this.childViews) {
            for (let i = 0; i < this.childViews.length; i++) {
                this.childViews[i].initializeView();
            }
        }
        super.initializeView();
    }

    /**
     * @inheritDoc
     */
    updateViewContents() {
        this.updateChildViews();
    }

    /**
     * @private
     */
    updateChildViews() {
        if (this.childViews) {
            for (let i = 0; i < this.childViews.length; i++) {
                this.childViews[i].updateView();
            }
        }
    }

}